import * as React from "react";
import { Form, Accordion, Container, Button, Loader, Header, Icon, Segment } from "semantic-ui-react";

import { QuestionnaireContainerOwnProps, QuestionnaireTypeProps } from "@teamprevent/common/questionnaires/QuestionnaireContainerProps";

import { renderQuestionnaireSections } from "../utils";
import { ConfirmedButton } from "../../confirmedButton/ConfirmedButton";

import { QuestionnaireContainerProvider } from "./QuestionnaireContainerContext";
import { useAutoSave } from "./useAutoSave";

export const AccordionQuestionnaireContainer = (props: QuestionnaireContainerOwnProps & QuestionnaireTypeProps) => {
    const { loaded, submit, saving, submitting } = useAutoSave(props);

    const renderSubmitButton = () => {
        if (props.readonly) {
            return null;
        }
        return (
            <Container>
                <Form.Field>
                    {props.otherActionButtons}
                    {props.submissionConfirmationText && (!props.shouldShowSubmissionConfirmation || props.shouldShowSubmissionConfirmation()) ?
                        <ConfirmedButton
                            content="Submit"
                            className="submit"
                            onClick={submit}
                            promptText={props.submissionConfirmationText}
                            confirmButtonColor="green"
                        /> :
                        <Button
                            content="Submit"
                            className="submit"
                            loading={submitting}
                        />
                    }
                </Form.Field>
            </Container>
        );
    };

    if (props.loading || loaded === false) {
        return (
            <Loader active />
        );
    }

    return (
        <QuestionnaireContainerProvider questionnaireKey={props.questionnaireKey} readonly={props.readonly} extraQuestionContent={props.extraQuestionContent}>
            <Form onSubmit={submit} className="questionnaire">
                <Form.Field>
                    <Accordion styled fluid>
                        {renderQuestionnaireSections(props, props.children)}
                    </Accordion>
                </Form.Field>
                {renderSubmitButton()}
                {saving && <Segment textAlign="center" className="floating-loading-bar">
                    <Header>Saving <Icon loading name="spinner" /></Header>
                </Segment>}
            </Form>
        </QuestionnaireContainerProvider>
    );
};
